/**
 * The 404 component
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import Page from "../components/Page";
import ScrollToTop from "../components/Utils/Scroll/ScrollToTop";

const FourOFour = (props, context) => {
  return (
    <Page id="404" title={context.t("Page not found")}>
      <ScrollToTop />
      <section className="fourofour__hero">
        <Container>
          <Row>
            <Col xs={12}>
              <h1>{context.t("Page not found")}</h1>
            </Col>
            <Col
              className="fourofour__container__cta"
              xs={{ size: 6, offset: 3 }}
              md={{ size: 4, offset: 4 }}
            >
              <Link to={`/`} className="btn btn-primary w-100">
                {context.t("Back to Home")}
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </Page>
  );
};
/**  define proptype for the 'translation' function  */
FourOFour.contextTypes = {
  t: PropTypes.func,
};
export default FourOFour;
